import React, { useContext } from 'react';
import roles from './roles';

// Icons
import DashboardLogo from '@material-ui/icons/Dashboard';
import BarChartLogo from '@material-ui/icons/BarChart';
import People from '@material-ui/icons/People';
import MoveToInbox from '@material-ui/icons/MoveToInbox';
import PersonAdd from '@material-ui/icons/PersonAdd';
import SettingsApplicationsOutlined from '@material-ui/icons/SettingsApplicationsOutlined';
import InsertChartOutlined from '@material-ui/icons/InsertChartOutlined';
import AssignmentLogo from '@material-ui/icons/Assignment';
import PhoneIcon from '@material-ui/icons/Phone';
import GetAppLogo from '@material-ui/icons/GetApp';

// Components
import {
  AdminDashboard,
  QaDashboard,
  CallManagerDashboard,
} from '../pages/dashboard';
import { AllOrders, QaAllOrders, IntegrateWithSalesforce } from '../pages/orders';
import {
  OrderDetail,
  OrdersGridByStatus,
  QaOrdersGrid,
  UnderwriterOrdersGrid,
  ClientOrdersGrid,
  FieldRepOrdersGrid,
  OrdersInFieldRepReview,
  QaTimeTrackingGrid,
} from '../components/Orders';
import { ClientGrid, ClientTabs } from '../components/Clients';
import { ClientDetailTab } from '../components/Clients/tabs';
import { AdminUsersGrid, AdminUsersDetail, AdminUsersCreate } from '../components/Users/Admin';
import { InspectorUsersGrid, InspectorUsersDetail } from '../components/Users/Inspector';
import { QaUsersGrid, QaUsersCreate, QaUsersDetail } from '../components/Users/Qa';
import { UnderwriterUsersGrid, UnderwriterUsersCreate, UnderwriterUsersDetail } from '../components/Users/Underwriter';
import { ClientUsersCreate, ClientUsersDetail, ClientUsersGrid } from '../components/Users/Client';
import { CallCenterUsersGrid, CallCenterUsersCreate, CallCenterUsersDetail } from '../components/Users/CallCenter';
import { RestrictionsGrid, RestrictionsEdit, RestrictionsCreate } from '../components/Users/Restrictions';
import { APIUserGrid, APIUserCreate, APIUserDetail } from '../components/Users/APIUser';

import { FileImport } from '../components/FileImport';
import { TestRCTXml } from '../components/RCT';
import QaOrderReview from '../components/QaOrderReview';
import { InspectorOrderReview } from '../components/InspectorOrderReview';
import {
  ClientAccounting,
  ClientAccountingHistory,
  IndividualAccounting,
  IndividualAccountingHistory,
  ThirdPartyCostReport,
  ClosedOrderReport,
  BetterviewReport,
  UnderwriterActionReport,
  NewRevenueReport,
} from '../pages/accounting';
import { PageNotFound } from '../pages/404';
import { Unauthorized } from '../pages/Unauthorized';
import { Login, ForgotPassword, ResetPassword, MfaVerification } from '../pages/login';
import { SelfInspectAuth } from '../pages/self-inspect-auth';
import { MyAccount } from '../pages/account/MyAccount';
import { FileImportForm } from '../components/FileImportForm';
import HazardScores from '../components/HazardScores/HazardScores';
import ClientPriceOverrides from '../components/ClientPriceOverrides';
import AgentMasterList from '../components/AgentMasterList';
import { FieldManagerUsersGrid, FieldManagerUsersDetail, FieldManagerUsersCreate } from '../components/Users/FieldManager';
import { FieldManagerStateBulkAssignment } from '../components/FieldManagerStateBulkAssignment';
import { Redirect } from '../pages/Redirect';
import { Redirect as RouterRedirect } from 'react-router-dom';
import InVisionIQPage from '../pages/client/InVisionIQPage';
import InVisionIQKpiDetailPage from '../pages/client/InVisionIQKpiDetailPage';
import { IQSurveyResults, SelfInspectOutcomes } from '../pages/formattedOutputs';

// SELF INSPECT
import { SelfInspectLogin, SelfInspectPortal, SelfInspectEdit } from '../pages/self-inspect';
import InVisionIQBetterviewPage from '../pages/client/InVisionIQBetterviewPage';
import InVisionIQVexcelPage from '../pages/client/InVisionIQVexcelPage';
import QaOrderReviewFRDesktopSwitcher from '../components/QaOrderReview/QaOrderReviewFRDesktopSwitcher';
import AgentCreateForm from '../components/FileImportForm/AgentCreateForm';
import FieldRepQAPrice from '../components/FieldRepQAPrice';
import { CallManagerSettingsForm } from '../components/CallManager/CallManagerSettingsForm';
import { CallMonitor } from '../pages/dashboard/CallMonitor';
import { CallAnalysis } from '../pages/dashboard/CallAnalysis';
import { AutomationsGrid, AutomationRunsGrid, AutomationLogsGrid, AutomationLogsDetail } from '../pages/automations';
import { AusumConfigurations } from '../components/AusumConfigurations';
import { SystemConfigurations } from '../components/SystemConfigurations/SystemConfigurations';
import { MfaManagementUsersGrid, MfaManagementUsersDetail } from '../components/UserManagement/MFA';

const { ADMIN, CLIENT, QA, UNDERWRITER, FIELD_REP, UNDERWRITER_READONLY, CALL_MANAGER, CALLCENTER } = roles;

export const router = [
  // LOGIN
  {
    route: '/login',
    exact: true,
    logo: null,
    label: 'Login',
    component: Login,
    hideNavLink: true,
    fullScreen: true,
    children: [
      {
        route: '',
        exact: true,
        logo: null,
        label: 'Login',
        component: Login,
        fullScreen: true,
      },
      {
        route: '/forgot-password',
        exact: true,
        logo: null,
        label: 'Forgot Password',
        component: ForgotPassword,
        fullScreen: true,
      },
      {
        route: '/reset-password/:token/:username',
        exact: true,
        logo: null,
        label: 'Reset Password',
        component: ResetPassword,
        fullScreen: true,
      },
      {
        route: '/mfa-verify',
        exact: true,
        logo: null,
        label: 'MFA Verification',
        component: MfaVerification,
        fullScreen: true,
      },
    ],
  },

  // MY ACCOUNT
  {
    route: '/my-account',
    exact: true,
    logo: null,
    label: '',
    component: MyAccount,
    hideNavLink: true,
  },

  // DASHBOARD
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [ADMIN],
    component: AdminDashboard,
  },
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [CLIENT],
    component: props => <ClientOrdersGrid {...props} />,
  },
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [QA],
    component: QaDashboard,
  },
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [FIELD_REP],
    component: FieldRepOrdersGrid,
  },
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [CALLCENTER],
    component: AllOrders,
  },
  {
    route: '/',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [CALL_MANAGER],
    component: CallManagerDashboard,
  },
  {
    route: '/',
    exact: true,
    hideNavLink: true,
    permissions: [UNDERWRITER, UNDERWRITER_READONLY],
    component: () => <RouterRedirect to="/orders" />,
  },

  // #region CLIENTS
  {
    route: '/clients',
    exact: true,
    logo: People,
    label: 'Clients',
    permissions: [ADMIN],
    hideChildrenNavLinks: true,
    children: [
      {
        route: '',
        exact: true,
        logo: null,
        label: 'Clients',
        component: ClientGrid,
      },
      {
        route: '/create',
        exact: true,
        logo: null,
        label: 'Clients',
        component: props => <ClientDetailTab {...props} pageMode="CREATE" useCardContainer />,
      },
      {
        route: '/:clientId',
        exact: true,
        logo: null,
        label: 'Clients',
        component: props => <ClientTabs {...props} />,
      },
    ],
  },
  // #endregion

  // #region ORDERS (underwriter + client)
  {
    route: '/orders',
    exact: true,
    logo: DashboardLogo,
    label: 'Dashboard',
    permissions: [UNDERWRITER, UNDERWRITER_READONLY],
    hideChildrenNavLinks: true,
    children: [
      {
        route: '',
        exact: true,
        logo: null,
        hideNavLink: true,
        permissions: [UNDERWRITER, UNDERWRITER_READONLY],
        pageTitle: 'Orders - Underwriter',
        component: UnderwriterOrdersGrid,
      },
      {
        route: '/create',
        exact: true,
        logo: null,
        hideNavLink: true,
        permissions: [UNDERWRITER],
        pageTitle: 'Create Order',
        component: props => <FileImportForm {...props} />,
      },
      {
        route: '/qa/:orderLineId',
        exact: true,
        logo: null,
        permissions: [UNDERWRITER, UNDERWRITER_READONLY],
        pageTitle: 'Underwriter Review',
        component: QaOrderReview,
        fullScreen: true,
        hideNavLink: true,
      },
      {
        route: '/:orderLineId',
        exact: true,
        logo: null,
        label: 'Order Details',
        hideNavLink: true,
        permissions: [UNDERWRITER, UNDERWRITER_READONLY],
        component: () => <RouterRedirect to="/orders" />,
      },
    ],
  },
  {
    route: '/orders',
    exact: true,
    hideNavLink: true,
    permissions: [CLIENT],
    children: [
      {
        route: '/create',
        exact: true,
        logo: null,
        hideNavLink: true,
        permissions: [CLIENT],
        pageTitle: 'Create Order',
        component: props => <FileImportForm {...props} />,
      },
      {
        route: '/:orderLineId',
        exact: true,
        logo: null,
        label: 'Order Details',
        hideNavLink: true,
        permissions: [CLIENT],
        component: () => <RouterRedirect to="/" />,
      },
    ],
  },
  // #endregion

  // #region CREATE ORDER (top-level sidebar item)
  {
    route: '/orders/create',
    exact: true,
    logo: MoveToInbox,
    label: 'Create Order',
    pageTitle: 'Create Order',
    permissions: [CLIENT, UNDERWRITER],
    component: props => <FileImportForm {...props} />,
  },
  // #endregion

  // #region ORDERS
  {
    route: '/orders',
    exact: true,
    logo: MoveToInbox,
    label: 'Orders',
    permissions: [ADMIN,CALLCENTER],
    children: [
      {
        route: '/all',
        exact: true,
        logo: null,
        label: 'All Orders',
        pageTitle: 'Orders',
        permissions: [ADMIN,CALLCENTER],
        component: AllOrders,
      },
      {
        route: '/qa',
        exact: true,
        logo: null,
        label: 'QA Orders',
        pageTitle: 'Orders - QA',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Orders - QA',
            component: QaOrdersGrid,
          },
          {
            route: '/:orderLineId',
            exact: true,
            logo: null,
            pageTitle: 'QA Review',
            component: QaOrderReview,
            fullScreen: true,
          },
        ],
      },
      {
        route: '/field-rep-review',
        exact: true,
        logo: null,
        label: 'Field Rep Review',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Orders - In Field Rep Review',
            component: OrdersInFieldRepReview,
          },
        ],
      },
      {
        route: '/qa-time-tracking',
        exact: true,
        logo: null,
        label: 'QA Time Tracking',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'QA Time Tracking',
            component: QaTimeTrackingGrid,
          },
        ],
      },
      {
        route: '/by-status',
        exact: true,
        logo: null,
        label: 'Status Grids',
        pageTitle: 'Orders',
        permissions: [ADMIN],
        component: OrdersGridByStatus,
        hideNavLink: true,
      },
      {
        route: '/file-import',
        exact: true,
        logo: null,
        label: 'File Import',
        permissions: [ADMIN],
        component: FileImport,
      },
      {
        route: '/create',
        exact: true,
        logo: null,
        label: 'Create Order',
        pageTitle: 'Create Order',
        permissions: [ADMIN],
        component: props => <FileImportForm {...props} isAdmin />,
      },
      /*
      {
        route: '/integratewithsalesforce',
        exact: true,
        logo: null,
        label: 'Integrate With Salesforce',
        pageTitle: 'Integrate With Salesforce',
        component: IntegrateWithSalesforce,
      },
      */
      {
        route: '/:orderLineId',
        exact: true,
        logo: null,
        label: 'Order Details',
        hideNavLink: true,
        permissions: [ADMIN, QA, CALLCENTER],
        component: OrderDetail,
      },
    ],
  },

  // {
  //   route: '/qa-canceled',
  //   exact: true,
  //   logo: MoveToInbox,
  //   label: 'Canceled Orders',
  //   pageTitle: 'Canceled Orders',
  //   component: props => <QaOrdersGrid {...props} showCanceledOrdersOnly={true} />,
  //   permissions: [ADMIN,CALLCENTER],
  //   // usernamePermissions: QA_CANCELED_GRID_USERNAMES,
  // },
  // #endregion

  // #region CLEINT USERS
  {
    route: '/users',
    exact: true,
    logo: PersonAdd,
    label: 'Users',
    permissions: [CLIENT],
    children: [
      // UNDERWRITER User Pages
      {
        route: '/underwriter',
        exact: true,
        logo: null,
        label: 'Underwriters',
        pageTitle: 'Users - UNDERWRITER',
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - UNDERWRITER',
            component: UnderwriterUsersGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create an UNDERWRITER User',
            component: UnderwriterUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - UNDERWRITER',
            component: UnderwriterUsersDetail,
          },
        ],
      },
    ],
  },
  // #endregion

  // #region USERS
  {
    route: '/users',
    exact: true,
    logo: PersonAdd,
    label: 'Users',
    permissions: [ADMIN,CALLCENTER],
    children: [
      // ADMIN User Pages
      {
        route: '/admin',
        exact: true,
        logo: null,
        label: 'Admin',
        pageTitle: 'Users - Admin',
        hideChildrenNavLinks: true,
    permissions: [ADMIN],
    children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - Admin',
            component: AdminUsersGrid,
          },
          {
            route: '/me',
            exact: true,
            logo: null,
            pageTitle: 'My Account',
            component: AdminUsersDetail,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create an ADMIN User',
            component: AdminUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - Admin',
            component: AdminUsersDetail,
          },
        ],
      },
      // CLIENT User Pages
      {
        route: '/client',
        exact: true,
        logo: null,
        label: 'Clients',
        pageTitle: 'Users - CLIENT',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - CLIENT',
            component: ClientUsersGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create a CLIENT User',
            component: ClientUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - CLIENT',
            component: ClientUsersDetail,
          },
        ],
      },
      // FIELDREP User Pages
      {
        route: '/field-reps',
        exact: true,
        logo: null,
        label: 'Field Reps',
        pageTitle: 'Users - Field Reps',
        hideChildrenNavLinks: true,
        permissions: [ADMIN,CALLCENTER],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - Field Reps',
            component: InspectorUsersGrid,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - Field Reps',
            component: InspectorUsersDetail,
          },
        ],
      },

      // Field Manager Pages
      {
        route: '/field-managers',
        exact: true,
        logo: null,
        label: 'Field Managers',
        pageTitle: 'Users - Field Managers',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - Field Manager',
            component: FieldManagerUsersGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create a Field Manager',
            component: FieldManagerUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - Field Manager',
            component: FieldManagerUsersDetail,
          },
          // {
          //   route: '/state-assignment',
          //   exact: true,
          //   logo: null,
          //   pageTitle: 'Field Manager - State Assignment',
          //   component: FieldManagerBulkAssignToStates,
          // },
        ],
      },

      // QA User Pages
      {
        route: '/qa',
        exact: true,
        logo: null,
        label: 'QA',
        pageTitle: 'Users - QA',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - QA',
            component: QaUsersGrid,
          },
          // {
          //   route: '/create',
          //   exact: true,
          //   logo: null,
          //   pageTitle: 'Users - Create a QA User',
          //   component: QaUsersDetail,
          // },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - QA',
            component: QaUsersDetail,
          },
        ],
      },

      // CALL CENTER User Pages
      {
        route: '/callcenter',
        exact: true,
        logo: null,
        label: 'Call Center',
        pageTitle: 'Users - Call Center',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - Call Center',
            component: CallCenterUsersGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create a Call Center User',
            component: CallCenterUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - Call Center',
            component: CallCenterUsersDetail,
          },
        ],
      },

      // UNDERWRITER User Pages
      {
        route: '/underwriter',
        exact: true,
        logo: null,
        label: 'Underwriters',
        pageTitle: 'Users - UNDERWRITER',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - UNDERWRITER',
            component: UnderwriterUsersGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create an UNDERWRITER User',
            component: UnderwriterUsersCreate,
          },
          {
            route: '/:userId',
            logo: null,
            pageTitle: 'Users - UNDERWRITER',
            component: UnderwriterUsersDetail,
          },
        ],
      },

      // ADMIN User Pages
      {
        route: '/restrictions',
        exact: true,
        logo: null,
        label: 'Restrictions',
        pageTitle: 'Users - RESTRICTIONS',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
          children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - RESTRICTIONS',
            component: RestrictionsGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create Restrictions',
            component: RestrictionsCreate,
          },
          {
            route: '/:userId',
            exact: true,
            logo: null,
            pageTitle: 'Users - Edit Restrictions',
            component: RestrictionsEdit,
          },
        ],
      },
      // API User Pages
      {
        route: '/api-users',
        exact: true,
        logo: null,
        label: 'API Users',
        pageTitle: 'Users - API Users',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'Users - API Users',
            component: APIUserGrid,
          },
          {
            route: '/create',
            exact: true,
            logo: null,
            pageTitle: 'Users - Create an API User',
            component: APIUserCreate,
          },
          {
            route: '/:apiUserId',
            exact: true,
            logo: null,
            pageTitle: 'Users - API User',
            component: APIUserDetail,
          },
        ],
      }
    ],
  },
  // #endregion

  // #region USER MANAGEMENT
  {
    route: '/user-management',
    exact: true,
    logo: SettingsApplicationsOutlined,
    label: 'User Management',
    permissions: [ADMIN],
    children: [
      // MFA Management
      {
        route: '/mfa-management',
        exact: true,
        logo: null,
        label: 'MFA Management',
        pageTitle: 'User Management - MFA Management',
        hideChildrenNavLinks: true,
        permissions: [ADMIN],
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            pageTitle: 'User Management - MFA Management',
            component: MfaManagementUsersGrid,
          },
          {
            route: '/:userId',
            exact: true,
            logo: null,
            pageTitle: 'User Management - MFA Management User',
            component: MfaManagementUsersDetail,
          },
        ],
      },
    ],
  },
  // #endregion

  {
    route: '/orders/qa',
    exact: true,
    logo: MoveToInbox,
    label: 'Orders',
    permissions: [QA],
    pageTitle: 'Orders - QA',
    component: props => <QaOrdersGrid {...props} allowBulkAssign />,
  },
  {
    route: '/orders/qa/:orderLineId',
    exact: true,
    logo: null,
    permissions: [QA,CALLCENTER],
    pageTitle: 'QA Review',
    component: QaOrderReview,
    fullScreen: true,
    hideNavLink: true,
  },
  {
    route: '/orders/:orderLineId',
    exact: true,
    logo: null,
    label: 'Order Details',
    hideNavLink: true,
    permissions: [QA],
    component: OrderDetail,
  },
  {
    route: '/orders-all',
    exact: true,
    logo: MoveToInbox,
    label: 'All Orders',
    pageTitle: 'All Orders',
    permissions: [QA],
    requiresOption: 'canProcessCancel',
    component: QaAllOrders,
  },

  /**
   * FIELD REPS
   */
  {
    route: '/orders/review/:orderLineId',
    exact: true,
    logo: null,
    permissions: [FIELD_REP],
    pageTitle: 'Field Rep Review',
    component: QaOrderReview, // InspectorOrderReview || QaOrderReviewFRDesktopSwitcher
    fullScreen: true,
    hideNavLink: true,
  },
  {
    route: '/orders/callcenterreview/:orderLineId',
    exact: true,
    logo: null,
    permissions: [CALLCENTER],
    pageTitle: 'Call Center Review',
    component: QaOrderReview, // InspectorOrderReview || QaOrderReviewFRDesktopSwitcher
    fullScreen: true,
    hideNavLink: true,
  },
  {
    route: '/orders/:orderLineId',
    exact: true,
    logo: null,
    label: 'Order Details',
    hideNavLink: true,
    permissions: [FIELD_REP],
    component: OrderDetail,
  },

  // REPORTS
  {
    route: '/accounting',
    exact: true,
    logo: InsertChartOutlined,
    label: 'Accounting',
    permissions: [ADMIN],
    children: [
      {
        route: '/field-reps',
        exact: true,
        logo: null,
        label: 'Field Rep Payroll',
        pageTitle: 'Field Rep Payroll',
        component: props => <IndividualAccounting {...props} reportType={'INSPECTOR'} />,
      },
      {
        route: '/field-reps/history',
        exact: true,
        logo: null,
        label: 'Field Rep Payroll History',
        pageTitle: 'Field Rep Payroll History',
        hideNavLink: true,
        component: props => <IndividualAccountingHistory {...props} reportType={'INSPECTOR'} />,
      },
      {
        route: '/qa',
        exact: true,
        logo: null,
        label: 'QA Payroll',
        pageTitle: 'QA Payroll',
        component: props => <IndividualAccounting {...props} reportType={'QA'} />,
      },
      {
        route: '/qa/history',
        exact: true,
        logo: null,
        label: 'QA Payroll History',
        hideNavLink: true,
        pageTitle: 'QA Payroll History',
        component: props => <IndividualAccountingHistory {...props} reportType={'QA'} />,
      },
      {
        route: '/clients',
        exact: true,
        logo: null,
        label: 'Client Invoicing',
        pageTitle: 'Client Invoicing',
        component: ClientAccounting,
      },
      {
        route: '/clients/history',
        exact: true,
        logo: null,
        label: 'Client Invoicing History',
        hideNavLink: true,
        pageTitle: 'Client Invoicing History',
        component: ClientAccountingHistory,
      },
      {
        route: '/3rd Party Cost Report',
        exact: true,
        logo: null,
        label: '3rd Party Cost Report',
        pageTitle: '3rd Party Cost Report',
        component: ThirdPartyCostReport,
      },
      {
        route: '/Closed Order Report',
        exact: true,
        logo: null,
        label: 'Closed Order Report',
        pageTitle: 'Closed Order Report/Data File',
        component: ClosedOrderReport,
      },
      {
        route: '/Betterview Report',
        exact: true,
        logo: null,
        label: 'Betterview Report',
        pageTitle: 'Betterview Report',
        component: BetterviewReport,
      },
      {
        route: '/Underwriter Action Report',
        exact: true,
        logo: null,
        label: 'Underwriter Action Report',
        pageTitle: 'Underwriter Action Report',
        component: UnderwriterActionReport,
      },
      {
        route: '/NewRevenueReport',
        exact: true,
        logo: null,
        label: 'New Revenue Report',
        pageTitle: 'New Revenue Report/Data File',
        component: NewRevenueReport,
      },
    ],
  },

  // SETTINGS
  {
    route: '/settings',
    exact: true,
    logo: SettingsApplicationsOutlined,
    label: 'Settings',
    permissions: [ADMIN],
    children: [
      {
        route: '/hazard-scores-columns',
        exact: true,
        logo: AssignmentLogo,
        label: 'Hazard Scores',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'Hazard Scores',
            component: HazardScores,
          },
        ],
      },
      {
        route: '/payable-configurations',
        exact: true,
        logo: AssignmentLogo,
        label: 'Payable Configurations',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'Payable Configurations',
            component: FieldRepQAPrice,
          },
        ],
      },
      {
        route: '/client-product-configuration',
        exact: true,
        // logo: AssignmentLogo,
        label: 'Client Product Configuration',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'Client Product Configuration',
            component: ClientPriceOverrides,
          },
        ],
      },
      {
        route: '/field-manager-assignment',
        exact: true,
        logo: AssignmentLogo,
        label: 'Field Manager Assignment',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'Field Manager State Assignment',
            component: FieldManagerStateBulkAssignment,
          },
        ],
      },
      {
        route: '/ausum-configurations',
        exact: true,
        logo: AssignmentLogo,
        label: 'Ausum Configurations',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'Ausum Configurations',
            component: AusumConfigurations,
          },
        ],
      },

      {
        route: '/system-configurations',
        exact: true,
        logo: AssignmentLogo,
        label: 'System Configurations',
        permissions: [ADMIN],
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            label: 'System Configurations',
            component: SystemConfigurations,
          },
        ],
      },

      {
        route: '/RCT',
        exact: true,
        logo: AssignmentLogo,
        label: 'RCT',
        permissions: [ADMIN],
        hideNavLink: true,
        hideChildrenNavLinks: true,
        children: [
          {
            route: '',
            exact: true,
            logo: null,
            permissions: [ADMIN],
            label: 'RCT',
            component: TestRCTXml,
          },
          {
            route: '/:rctTestFile',
            exact: true,
            logo: null,
            permissions: [ADMIN],
            label: 'RCT',
            component: TestRCTXml,
          },
        ],
      },
    ],
  },

  // FORMATTED OUTPUTS
  {
    route: '/formatted-outputs',
    exact: true,
    logo: GetAppLogo,
    label: 'Formatted Outputs',
    permissions: [ADMIN],
    children: [
      {
        route: '/IQ Survey Results',
        exact: true,
        logo: null,
        label: 'IQ Survey Results',
        pageTitle: 'IQ Survey Results',
        component: IQSurveyResults,
      },
      {
        route: '/self-inspect-outcomes',
        exact: true,
        logo: null,
        label: 'Self Inspect Outcomes',
        pageTitle: 'Self Inspect Outcomes',
        component: SelfInspectOutcomes,
      },
    ],
  },

  /**
   * START SELF INSPECT
   */
  {
    route: '/self-inspect-auth',
    exact: true,
    logo: null,
    label: 'Self Inspect',
    component: SelfInspectAuth,
    hideNavLink: true,
    fullScreen: true,
  },
  /*
  {
    route: '/self-inspect-login',
    exact: true,
    logo: null,
    label: 'Self Inspect Login',
    component: SelfInspectLogin,
    // hideNavLink: true,
    fullScreen: true,
  }, */
  {
    route: '/invisioniq/edit/:orderKey',
    exact: true,
    logo: null,
    label: 'InVisionIQ',
    component: SelfInspectEdit,
    hideNavLink: true,
    fullScreen: true,
  },
  {
    route: '/invisioniq',
    exact: true,
    logo: null,
    label: 'InVisionIQ',
    component: SelfInspectPortal,
    hideNavLink: true,
    fullScreen: true,
  },
  {
    route: '/invisioniq/:orderKey',
    exact: true,
    logo: null,
    label: 'InVisionIQ',
    component: SelfInspectPortal,
    hideNavLink: true,
    fullScreen: true,
  },
  /**
   * END SELF INSPECT
   */

  {
    route: '/quickvue-virtual-dashboard',
    exact: true,
    logo: BarChartLogo,
    label: 'QuickVUE',
    pageTitle: 'QuickVUE Virtual Dashboard',
    permissions: [ADMIN, CLIENT, UNDERWRITER],
    component: InVisionIQPage,
  },
  {
    route: '/quickvue-virtual-dashboard/:kpiId',
    exact: true,
    hideNavLink: true,
    pageTitle: 'QuickVUE Virtual Dashboard',
    permissions: [ADMIN, CLIENT, UNDERWRITER],
    component: InVisionIQKpiDetailPage,
  },
  {
    route: '/quickvue-betterview-preview/:orderKey',
    exact: true,
    hideNavLink: true,
    pageTitle: 'Betterview Report',
    permissions: [ADMIN, CLIENT, UNDERWRITER],
    component: InVisionIQBetterviewPage,
  },
  {
    route: '/quickvue-Vexcel-preview/:orderKey',
    exact: true,
    hideNavLink: true,
    pageTitle: 'Vexcel Report',
    permissions: [ADMIN, CLIENT, UNDERWRITER],
    component: InVisionIQVexcelPage,
  },

  {
    route: '/redirect',
    exact: true,
    logo: null,
    hideNavLink: true,
    component: Redirect,
  },

  // Temporary testing route - remove before production
  {
    route: '/call-manager',
    exact: true,
    logo: PhoneIcon,
    label: 'Call Manager',
    component: CallManagerDashboard,
    permissions: [ADMIN,CALLCENTER],
  },
  {
    route: '/call-manager/settings',
    exact: true,
    hideNavLink: true,
    logo: PhoneIcon,
    label: 'Call Manager Settings',
    component: CallManagerSettingsForm,
  },
  {
    route: '/call-manager/monitor/:orderLineId',
    exact: true,
    hideNavLink: true,
    label: 'Call Monitor',
    component: CallMonitor,
  },
  {
    route: '/call-manager/analysis/:providerCallId',
    exact: true,
    hideNavLink: true,
    label: 'Call Analysis',
    component: CallAnalysis,
  },

  {
    route: '/unauthorized',
    hideNavLink: true,
    component: Unauthorized,
  },

  // #region AUTOMATIONS
  {
    route: '/automations',
    exact: true,
    logo: SettingsApplicationsOutlined,
    label: 'Automations',
    permissions: [ADMIN],
    pageTitle: 'Automations',
    hideChildrenNavLinks: true,
    children: [
      {
        route: '',
        exact: true,
        logo: null,
        label: 'Automations',
        permissions: [ADMIN],
        pageTitle: 'Automations',
        component: AutomationsGrid,
      },
      {
        route: '/:automationId',
        exact: true,
        logo: null,
        label: 'Automations',
        permissions: [ADMIN],
        component: AutomationRunsGrid,
      },
      {
        route: '/:automationId/:automationRunId',
        exact: true,
        logo: null,
        label: 'Automation Runs',
        permissions: [ADMIN],
        component: AutomationLogsGrid,
      },
      {
        route: '/:automationId/:automationRunId/:automationLogId',
        exact: true,
        logo: null,
        label: 'Automation Logs',
        permissions: [ADMIN],
        component: AutomationLogsDetail,
      },
    ],
  },

  // #endregion

  {
    route: '*',
    hideNavLink: true,
    component: PageNotFound,
  },
];
